import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { Flex, Spin, Button, Result } from "antd"
import { LinkOutlined } from "@ant-design/icons"
import { Text } from "ui/Typography"
import { resolveShortLink } from "store/short-link"
import styles from "./ShortLinkRedirect.module.css"

const ShortLinkRedirect = () => {
  const { token } = useParams()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [error, setError] = useState(null)

  useEffect(() => {
    dispatch(resolveShortLink(token))
      .then((res) => {
        if (res?.target_url) {
          const url = new URL(res.target_url, window.location.origin)
          if (url.origin !== window.location.origin) {
            setError("not_found")
            return
          }
          window.location.assign(url.pathname + url.search + url.hash)
        } else {
          setError("not_found")
        }
      })
      .catch((err) => {
        setError(err?.status === 410 ? "expired" : "not_found")
      })
  }, [token, dispatch])

  if (error) {
    return (
      <Flex align="center" justify="center" className={styles.container}>
        <Result
          icon={<LinkOutlined className={styles.icon} />}
          status="404"
          title={<Text className={styles.title}>{t(`short_link.${error}_title`)}</Text>}
          subTitle={<Text className={styles.subtitle}>{t(`short_link.${error}_subtitle`)}</Text>}
          extra={
            <Flex justify="center" className={styles.buttonContainer}>
              <Button type="primary" size="large" onClick={() => window.location.assign("/")}>
                {t("short_link.go_to_home")}
              </Button>
            </Flex>
          }
        />
      </Flex>
    )
  }

  return (
    <Flex align="center" justify="center" className={styles.container}>
      <Spin size="large" />
    </Flex>
  )
}

export default ShortLinkRedirect
